<template>
  <v-row>
    <!-- Add Access Host -->
    <v-col cols="12">
      <add-access-host-form @reload-table="reloadTable"></add-access-host-form>
    </v-col>
    <!-- Manage Access Hosts -->
    <v-col cols="12">
      <hosts-table @table-reloaded="tableReloaded"
                   :table-should-be-reloaded="tableShouldBeReloaded"
      />
    </v-col>
  </v-row>
</template>

<script>
import AddAccessHostForm from '@/components/Services/Hosting/Shared/Mysql/Remote/AddAccessHostForm'
import HostsTable from '@/components/Services/Hosting/Shared/Mysql/Remote/HostsTable'

export default {
  name: 'RemoteMySQLView',
  components: {
    AddAccessHostForm,
    HostsTable,
  },
  data () {
    return {
      tableShouldBeReloaded: false,
    }
  },
  methods: {
    reloadTable () {
      this.tableShouldBeReloaded = true
    },
    tableReloaded () {
      this.tableShouldBeReloaded = false
    },
  },
}
</script>
